/**
 * The Organization class acts as the view object for the organization.
 */
const tbs_model_vo_Organization = function() {
}

//--------------------------------------------------
// prototype
//--------------------------------------------------
tbs_model_vo_Organization.prototype = {
    /* The view object name */
    name: 'organization',
    /* The view object instance */
    view: {
        query: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'getMyMatchOrganizationList',
            basePath: 'data.list',
            rule: {
                id: '~id',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',
                contact: 'contact',
                position: 'role',
                teamTotal: "teamCount",
                gameTotal: "gameCount"
            }
        },
        get: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'GetCrmAccount2',
            basePath: 'data.account',
            rule: {
                id: '~id',
                name: 'name',
                logoUrl: 'logo',
                area: '$country,province,city,district',
                areaId: '$countryId,provinceId,cityId,districtId',
                contact: 'contact',
                position: 'role'
            }
        },
        create: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'CreateCrmAccount2',
            basePath: '',
            rule: {
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                contact: 'contact',
                role: 'position',
                sport: 'sportType'
            }
        },
        update: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'UpdateCrmAccount2',
            basePath: '',
            rule: {
                id: 'id',
                name: 'name',
                logo: 'logo',
                areaId: 'areaId',
                area: 'area',
                contact: 'contact',
                role: 'position',
                sport: 'sportType'
            }
        },
        remove: {
            baseUrl: process.env.VUE_APP_BANMA_API,
            apiPrefix: '/bmmatch/',
            service: 'DeleteCrmAccount2',
            basePath: '',
            rule: {
                id: 'id'
            }
        },
    },
    //--------------------------------------------------
    // private method
    //--------------------------------------------------
    renderArea: function(country, province, city, district) {
        let area = ''
        if (country && !province) {
            area = country
        }
        else {
            area = province
        }
        if (city) {
            area += ' ' + city
        }
        if (district) {
            area += ' ' + district
        }
        return area
    },
    renderAreaId: function(countryId, provinceId, cityId, districtId) {
        let areaId = countryId
        if (provinceId) {
            areaId = provinceId
        }
        if (cityId) {
            areaId = cityId
        }
        if (districtId) {
            areaId = districtId
        }
        return areaId
    },
}

module.exports = tbs_model_vo_Organization